import { routeConstant } from "shared/routes/routeConstant";
import { SUPPORTED_FORMATS } from "./enum";
import { store } from "shared/redux/store";
import { resetAuthReducer } from "shared/redux/reducers/authSlice";
import { toastMessage } from "shared/components/common/toast";
import { resetArchiveCountReducer } from "shared/redux/reducers/archiveCount";
import { resetQuestionnaireReducer } from "shared/redux/reducers/questionnaire";
import { resetTheme } from "shared/redux/reducers/theme";

function getWindowDimensions() {
  if (typeof window !== "undefined") {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  } else {
    return {
      width: 0,
      height: 0,
    };
  }
}

function isImage(filetype: string): boolean {
  if (SUPPORTED_FORMATS.includes(filetype)) {
    return true;
  } else {
    return false;
  }
}

function findScreenTitle(pathname: string) {
  let arr: any = Object.values(routeConstant).filter(
    (itm: any) => itm?.path === pathname
  );
  if (arr?.length > 0) {
    return arr[0]?.title;
  } else {
    return "";
  }
}

const resetRedux = () => {
  const { auth }: any = store.getState().root;
  if (auth?.token) {
    store.dispatch(resetTheme());
    store.dispatch(resetAuthReducer());
    store.dispatch(resetArchiveCountReducer());
    store.dispatch(resetQuestionnaireReducer());
    toastMessage("error", "Session Expired");
  }
};

function getTopPosition(divElement: HTMLElement) {
  const rect = divElement.getBoundingClientRect();
  const top = rect.top - document.documentElement.clientTop;
  return top;
}

function getLeftPosition(divElement: HTMLElement) {
  const rect = divElement.getBoundingClientRect();
  const left = rect.left - document.documentElement.clientLeft;
  return left;
}

function getDistanceBetweenDivs(div1: HTMLElement, div2: HTMLElement) {
  const rect1 = div1.getBoundingClientRect();
  const rect2 = div2.getBoundingClientRect();

  // Calculate the horizontal distance (x-axis)
  const deltaX =
    Math.abs(rect1.x - rect2.x) -
    Math.max(
      0,
      rect1.width +
        rect2.width -
        (rect1.x + rect1.width) -
        (rect2.x + rect2.width)
    );

  // Calculate the vertical distance (y-axis)
  const deltaY =
    Math.abs(rect1.y - rect2.y) -
    Math.max(
      0,
      rect1.height +
        rect2.height -
        (rect1.y + rect1.height) -
        (rect2.y + rect2.height)
    );

  // Use Pythagoras theorem to calculate the total distance
  const distance = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));

  return distance;
}

function mergeArrays(step: number, fullArr: any[], currentStepArr: any[]) {
  if (step === 1) {
    if (fullArr.length > 0) {
      const tempFilteredArr = currentStepArr.map((item, idx) => {
        const matchingFullObj = fullArr.find(
          (fullItem) => fullItem.id === item.id
        );
        if (matchingFullObj) {
          if (matchingFullObj?.roleType?.value !== item?.roleType?.value) {
            return { ...item };
          } else {
            return { ...matchingFullObj, ...item };
          }
        } else return { ...item };
      });
      fullArr = tempFilteredArr;
    } else {
      fullArr = [...currentStepArr];
    }
  } else if (step === 2) {
    fullArr = fullArr.map((itm, idx) => {
      let currentStepItem = currentStepArr[idx];
      if (
        currentStepItem?.levelWork?.value !== itm?.q1?.levelWork?.value ||
        currentStepItem?.modifier?.value !== itm?.q1?.modifier?.value
      ) {
        return {
          id: itm?.id,
          jobTitle: itm?.jobTitle,
          department: itm?.department,
          jobCode: itm?.jobCode,
          jobGrade: itm?.jobGrade,
          roleType: itm?.roleType,
          rasScore: itm?.rasScore,
          rasLevel: itm?.rasLevel,
          shortCode: itm?.shortCode,
          q1: currentStepItem,
        };
      } else {
        return { ...itm, q1: { ...currentStepItem } };
      }
    });
  } else if (step === 3) {
    fullArr = fullArr.map((itm, idx) => {
      let currentStepItem = currentStepArr[idx];
      return { ...itm, q2: { ...currentStepItem } };
    });
  } else if (step === 4) {
    fullArr = fullArr.map((itm, idx) => {
      let currentStepItem = currentStepArr[idx];
      return { ...itm, q3: { ...currentStepItem } };
    });
  } else if (step === 5) {
    fullArr = fullArr.map((itm, idx) => {
      let currentStepItem = currentStepArr[idx];
      return { ...itm, q4: { ...currentStepItem } };
    });
  } else if (step === 6) {
    fullArr = fullArr.map((itm, idx) => {
      let currentStepItem = currentStepArr[idx];
      return { ...itm, q5: { ...currentStepItem } };
    });
  } else if (step === 7) {
    fullArr = fullArr.map((itm, idx) => {
      let currentStepItem = currentStepArr[idx];
      return { ...itm, q6: { ...currentStepItem } };
    });
  } else if (step === 8) {
    fullArr = fullArr.map((itm, idx) => {
      let currentStepItem = currentStepArr[idx];
      return { ...itm, q7: { ...currentStepItem } };
    });
  } else if (step === 9) {
    fullArr = fullArr.map((itm, idx) => {
      let currentStepItem = currentStepArr[idx];
      return { ...itm, q8: { ...currentStepItem } };
    });
  } else if (step === 10) {
    fullArr = fullArr.map((itm, idx) => {
      let currentStepItem = currentStepArr[idx];
      return { ...itm, q9: { ...currentStepItem } };
    });
  }
  return fullArr;
}

function getPercentagefromString(num: string) {
  let number = num?.replace("%", "");
  let value = Number(Number(number) / 100);
  return value + 1;
}

function getNestedValue(obj: any, key: string) {
  return key.split(".").reduce((o, i) => (o ? o[i] : null), obj);
}

function sortJobsByKey(jobsArray: any[], key: string, reverse = false) {
  return jobsArray.sort((a, b) => {
    const keyA = getNestedValue(a, key);
    const keyB = getNestedValue(b, key);

    if (keyA === null || keyB === null) {
      return 0;
    }

    let comparison = 0;

    // Handle different types
    if (typeof keyA === "string" && typeof keyB === "string") {
      const valueA = keyA.toUpperCase(); // convert to uppercase to ignore case
      const valueB = keyB.toUpperCase(); // convert to uppercase to ignore case
      comparison = valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
    } else if (typeof keyA === "number" && typeof keyB === "number") {
      comparison = keyA - keyB;
    } else if (typeof keyA === "boolean" && typeof keyB === "boolean") {
      comparison = keyA === keyB ? 0 : keyA ? -1 : 1;
    } else if (Date.parse(keyA) && Date.parse(keyB)) {
      // Handle dates
      const dateA = new Date(keyA);
      const dateB = new Date(keyB);
      comparison = dateA.getTime() - dateB.getTime();
    }

    return reverse ? comparison * -1 : comparison;
  });
}

const GetQuestionStatement = (q_no: any) => {
  const {
    questions: { questions },
  }: any = store.getState().root;
  let filteredQuestions = questions.filter((itm: any) => itm?.q_no === q_no);
  return filteredQuestions[0]?.text;
};

function roundNum(number: string, decPlaces: number) {
  // 2 decimal places => 100, 3 => 1000, etc
  decPlaces = Math.pow(10, decPlaces);

  // Enumerate number abbreviations
  var abbrev = ["k", "m", "b", "t"];

  // Go through the array backwards, so we do the largest first
  for (var i = abbrev.length - 1; i >= 0; i--) {
    // Convert array index to "1000", "1000000", etc
    var size = Math.pow(10, (i + 1) * 3);

    // If the number is bigger or equal do the abbreviation
    if (size <= Number(number)) {
      // Here, we multiply by decPlaces, round, and then divide by decPlaces.
      // This gives us nice rounding to a particular decimal place.
      number = String(
        Math.round((Number(number) * decPlaces) / size) / decPlaces
      );

      // Handle special case where we round up to the next abbreviation
      if (Number(number) === 1000 && i < abbrev.length - 1) {
        number = String(1);
        i++;
      }

      // Add the letter for the abbreviation
      number += abbrev[i];

      // We are done... stop
      break;
    }
  }

  return number;
}

const getQueryforFilters = (payload: any) => {
  return `${payload.filter?.status ? `&status=${payload.filter?.status}` : ""}${
    payload.filter?.user ? `&user=${payload.filter?.user}` : ""
  }${payload.filter?.jobTitle ? `&jobTitle=${payload.filter?.jobTitle}` : ""}${
    payload.filter?.department
      ? `&department=${payload.filter?.department}`
      : ""
  }${payload.filter?.jobGrade ? `&jobGrade=${payload.filter?.jobGrade}` : ""}${
    payload.filter?.jobCode ? `&jobCode=${payload.filter?.jobCode}` : ""
  }${payload.filter?.roleType ? `&roleType=${payload.filter?.roleType}` : ""}${
    payload.filter?.modifier ? `&modifier=${payload.filter?.modifier}` : ""
  }${
    payload.filter?.levelOfWork
      ? `&levelOfWork=${payload.filter?.levelOfWork}`
      : ""
  }${payload.filter?.q2 ? `&q2=${payload.filter?.q2}` : ""}${
    payload.filter?.q3 ? `&q3=${payload.filter?.q3}` : ""
  }${payload.filter?.q4 ? `&q4=${payload.filter?.q4}` : ""}${
    payload.filter?.q5 ? `&q5=${payload.filter?.q5}` : ""
  }${payload.filter?.q6 ? `&q6=${payload.filter?.q6}` : ""}${
    payload.filter?.q7 ? `&q7=${payload.filter?.q7}` : ""
  }${payload.filter?.q8 ? `&q8=${payload.filter?.q8}` : ""}${
    payload.filter?.minScore ? `&minScore=${payload.filter?.minScore}` : ""
  }${payload.filter?.maxScore ? `&maxScore=${payload.filter?.maxScore}` : ""}${
    payload.filter?.minLvl ? `&minLvl=${payload.filter?.minLvl}` : ""
  }${payload.filter?.maxLvl ? `&maxLvl=${payload.filter?.maxLvl}` : ""}${
    payload.filter?.startDate ? `&startDate=${payload.filter?.startDate}` : ""
  }${payload.filter?.endDate ? `&endDate=${payload.filter?.endDate}` : ""}`;
};

const checkIfWarning = (jobs: any[], step: number) => {
  if (step === 3) {
    const hasWarning = jobs.some(
      (job) => job?.institutionalExpertise?.warning === 1
    );
    if (hasWarning) {
      return false;
    } else {
      return true;
    }
  } else if (step === 4) {
    const hasWarning = jobs.some((job) => job?.culturalImpact?.warning === 1);
    if (hasWarning) {
      return false;
    } else {
      return true;
    }
  } else if (step === 5) {
    const hasWarning = jobs.some(
      (job) => job?.physicalEnvironment?.warning === 1
    );
    if (hasWarning) {
      return false;
    } else {
      return true;
    }
  } else if (step === 6) {
    const hasWarning = jobs.some(
      (job) => job?.mentalEnvironment?.warning === 1
    );
    if (hasWarning) {
      return false;
    } else {
      return true;
    }
  } else if (step === 7) {
    const hasWarning = jobs.some((job) => job?.applicationLevel?.warning === 1);
    if (hasWarning) {
      return false;
    } else {
      return true;
    }
  } else if (step === 8) {
    const hasWarning = jobs.some((job) => job?.manualEffort?.warning === 1);
    if (hasWarning) {
      return false;
    } else {
      return true;
    }
  } else if (step === 9) {
    const hasWarning = jobs.some((job) => job?.outcomes?.warning === 1);
    if (hasWarning) {
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
};

const checkIfComplete = (formData: any[]) => {
  let isComplete: boolean[] = [];
  for (let i = 0; i < formData.length; i++) {
    let job = formData[i];
    if (
      job?.q1?.output !== undefined &&
      job?.q2?.output !== undefined &&
      job?.q3?.output !== undefined &&
      job?.q4?.output !== undefined &&
      job?.q5?.output !== undefined &&
      job?.q6?.output !== undefined &&
      job?.q7?.output !== undefined &&
      job?.q8?.output !== undefined
    ) {
      isComplete[i] = true;
    }
  }
  return isComplete.filter((itm) => itm === true).length === formData.length;
};

const checkDropdownOptions = (formData: any[]) => {
  let isComplete: boolean[] = [];
  for (let i = 0; i < formData.length; i++) {
    let job = formData[i];
    if (job?.q1?.alldropDowns?.length > 0) {
      isComplete[i] = true;
    }
  }
  return isComplete.filter((itm) => itm === true).length === formData.length;
};

function hasChanges(arr: any[], initialObj: any) {
  return arr.some((obj) => {
    // Iterate over the keys of the object dynamically
    for (let key in obj) {
      // Check if the value in obj differs from the corresponding value in initialObj
      if (obj[key] !== initialObj[key]) {
        return true; // Return true if any value differs
      }
    }
    return false; // If no differences, return false
  });
}

export {
  getWindowDimensions,
  isImage,
  findScreenTitle,
  resetRedux,
  getTopPosition,
  getLeftPosition,
  getDistanceBetweenDivs,
  mergeArrays,
  getPercentagefromString,
  getNestedValue,
  sortJobsByKey,
  GetQuestionStatement,
  roundNum,
  getQueryforFilters,
  checkIfWarning,
  checkIfComplete,
  checkDropdownOptions,
  hasChanges,
};
